import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import AddDigitalProduct from "../../images/addDigitalProduct.png"

const DigitalProducts = () => {
  const DigitalProductsDoc = {
    title: "Digital Products Inventory",
    description: "Learn how to efficiently manage your digital product inventory, including adding, updating, and categorizing products.",
    sections: [
      {
        title: "Overview",
        content: 
          "The Digital Products feature on the dashboard allows you to manage both existing and new digital products seamlessly. You can easily view and search for products categorized as All Products, In Stock, In Transit, Out of Stock, Verified, Unverified, Published, and Unpublished.",
      },
      {
        title: "Add Products",
        content: 
          "This feature allows you to add new digital products to the shop, with the option to include variants.",
        image: AddDigitalProduct,
        imageAlt: "Add Digital Products",
        imageCaption: "Figure 1: Comprehensive view of the Add Digital Product Dashboard",
        subsections: [
          {
            title: "Steps to Add a Product",
            content: 
              "Adding product variants allows you to offer the same product in different sizes, colors, styles, or brands. This is especially useful for items like wedding invitations, which may come in various options.",
            steps: [
              "Product Information: Fill in the essential details such as the product name, selling price, cost price, minimum order quantity (MOQ), country of origin, and currency. SKUs (Stock Keeping Units) will be automatically generated for each product.",
              "Category and Tags: Select from predefined categories for the product and add relevant tags to facilitate easier searching and filtering within the inventory.",
              "Inventory Management: Specify the stock quantity available and indicate whether the product is in limited quantity or always available for sale.",
              "Product Variants: Use this option to specify different variations of a product, such as differing colors, sizes, or brands.",
              "Product Media: Upload high-quality images of the product to provide a visual representation to potential customers.",
              "Publish: If you are uncertain about making a product live, you can use the draft functionality to save it without publishing immediately.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...DigitalProductsDoc} />;
};

export default DigitalProducts;
